import { Shield } from "lucide-react";

export function AccessDenied() {
  return <div role="alert" className="mx-auto mt-16 max-w-lg rounded-xl border border-red-200 bg-red-50 p-8 text-center dark:border-red-900 dark:bg-red-950/30"><Shield className="mx-auto mb-3 h-8 w-8 text-red-600" /><h1 className="text-xl font-semibold">Access Denied</h1><p className="mt-2 text-sm text-[hsl(var(--content-subtle))]">Administrator permissions are required to view this page.</p></div>;
}
